import { Box, Typography } from '@mui/material';
import { PieceHeading } from './PieceHeading';
import {
  HERO_PANEL_BG,
  HERO_PANEL_BORDER,
  HERO_TEXT_SECONDARY,
  HERO_TEXT_EYEBROW,
  HERO_SKILL_FILLED,
  HERO_SKILL_EMPTY,
  HERO_FONT_MONO,
} from '../designTokens';

const SKILLS = ['Kubernetes', 'Terraform', 'AWS', 'GitOps', 'Security'];
const PEOPLE = [
  { name: 'Alex Chen',    levels: [4, 3, 4, 2, 3] },
  { name: 'Priya Patel',  levels: [3, 4, 2, 4, 1] },
  { name: 'Jordan Kim',   levels: [2, 2, 3, 1, 4] },
  { name: 'Sam Williams', levels: [4, 3, 4, 3, 2] },
  { name: 'Lina Ortiz',   levels: [1, 2, 3, 2, 3] },
];
const COLS = SKILLS.length;

export function PieceSkills() {
  return (
    <Box sx={{ maxWidth: 520, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <PieceHeading
        eyebrow="Skills & practice management"
        line1="Know who knows what."
        line2="Staff with confidence."
      />
      <Box
        sx={{
          background: HERO_PANEL_BG,
          border: `1px solid ${HERO_PANEL_BORDER}`,
          borderRadius: '12px',
          p: '14px 16px',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `100px repeat(${COLS}, 1fr)`,
            alignItems: 'center',
            mb: 1,
            gap: 0.5,
            fontSize: '0.625rem',
            color: HERO_TEXT_EYEBROW,
            fontFamily: HERO_FONT_MONO,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}
        >
          <span />
          {SKILLS.map((s) => (
            <Typography
              key={s}
              component="span"
              sx={{
                textAlign: 'center',
                fontSize: 'inherit',
                color: 'inherit',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {s}
            </Typography>
          ))}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
          {PEOPLE.map((p) => (
            <Box
              key={p.name}
              sx={{
                display: 'grid',
                gridTemplateColumns: `100px repeat(${COLS}, 1fr)`,
                alignItems: 'center',
                gap: 0.5,
                fontSize: '0.71875rem',
                color: HERO_TEXT_SECONDARY,
              }}
            >
              <Typography
                component="span"
                sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: 'inherit', color: 'inherit' }}
              >
                {p.name}
              </Typography>
              {p.levels.map((lvl, j) => (
                <Box key={j} sx={{ display: 'flex', justifyContent: 'center', gap: '3px' }}>
                  {[0, 1, 2, 3].map((k) => (
                    <Box
                      key={k}
                      aria-hidden
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        background: k < lvl ? HERO_SKILL_FILLED : HERO_SKILL_EMPTY,
                      }}
                    />
                  ))}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
